module.exports = __webpack_public_path__ + "static/img/h5-bg3.59ee3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/h5-bg3.jpg
// module id = oWru
// module chunks = 0